/**
 * useAuth.ts
 * ----------
 * 로그인 상태 확인 유틸
 * - JWT exp로 토큰 유효성 확인
 * - 만료된 토큰은 자동 정리
 */

/**
 * JWT 페이로드는 Base64URL 인코딩(-, _ 사용, 패딩 없음)이라 표준 atob() 로 바로 디코딩하면
 * 페이로드에 -/_ 문자가 우연히 포함된 토큰에서 InvalidCharacterError 로 실패한다.
 * (세션마다 payload 바이트가 달라 -/_  포함 여부가 무작위 — 멀쩡한 토큰이 간헐적으로
 * "무효"로 오판되어 강제 로그아웃되는 원인이었음)
 */
function decodeJwtPayload(token: string): any {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  return JSON.parse(atob(padded));
}

/**
 * access_token JWT exp 유효성 확인
 */
export function isTokenValid(): boolean {
  const token = localStorage.getItem("access_token");
  if (!token) return false;
  try {
    const payload = decodeJwtPayload(token);
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

/**
 * refresh_token JWT exp 유효성 확인
 * - access 만료여도 refresh 유효하면 자동 재발급 가능 → 로그인 상태로 간주
 */
export function isRefreshValid(): boolean {
  const rt = localStorage.getItem("refresh_token");
  if (!rt) return false;
  try {
    const payload = decodeJwtPayload(rt);
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

/**
 * 로그인 상태 확인 — access 또는 refresh 중 하나만 유효해도 로그인으로 판정
 * (access 만료 시 다음 API 호출에서 401 인터셉터가 자동 refresh)
 */
export function isLoggedIn(): boolean {
  return isTokenValid() || isRefreshValid();
}

/**
 * 로그인 필요 동작 래퍼
 */
export function requireLogin(action: () => void, onLoginRequired: () => void): void {
  if (isLoggedIn()) {
    action();
  } else {
    onLoginRequired();
  }
}
